module.exports = __webpack_public_path__ + "static/media/validacion_iconos.0e622121.png";